module.exports = __webpack_public_path__ + "images/emoji/couple_with_heart.571f7491d67cf4da107e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/couple_with_heart.png
// module id = RhqC
// module chunks = 13